import React from "react";
import PropTypes from "prop-types";

/**
 * The banner every marketing page opens with. Shorter than the landing
 * carousel but built from the same dark ground, aurora wash and type scale, so
 * moving between pages feels like one site rather than four.
 */
const PageHero = ({ eyebrow, title, lead, children }) => (
  <section className="lp-hero pg-hero">
    <div className="lp-hero-glow" aria-hidden="true">
      <span />
      <span />
      <span />
    </div>

    <div className="lp-wrap">
      <div className="pg-hero-copy">
        <span className="lp-eyebrow" data-reveal>
          {eyebrow}
        </span>
        <h1 className="lp-quote" data-reveal data-reveal-delay="70">
          {title}
        </h1>
        <p className="lp-lead" data-reveal data-reveal-delay="130">
          {lead}
        </p>
        {children ? (
          <div className="lp-hero-cta" data-reveal data-reveal-delay="190">
            {children}
          </div>
        ) : null}
      </div>
    </div>
  </section>
);

PageHero.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  lead: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default PageHero;
